import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import { ContentProvider } from './context/ContentContext';
import { EditModeProvider } from './context/EditModeContext';
import { ActivityLogProvider } from './context/ActivityLogContext';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import SignInModal from './components/auth/SignInModal';
import ProfileSettingsModal from './components/auth/ProfileSettingsModal';
import EditModeBanner from './components/editable/EditModeBanner';
import EditorPanel from './components/editable/EditorPanel';
import RichTextToolbar from './components/editable/RichTextToolbar';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Home from './pages/home/home';
import Ministries from './pages/ministries/ministries';
import Beliefs from './pages/beliefs/beliefs';
import Gallery from './pages/gallery/gallery';
import Watch from './pages/watch/watch';
import Story from './pages/story/story';
import Visit from './pages/visitus/visit';
import NewHere from './pages/newhere/newhere';
import ActivityLog from './pages/admin/ActivityLog';
import Chatbot from './components/chatbot/Chatbot';
import Seo from './components/seo/Seo';

function App() {
  const [pageReveal, setPageReveal] = useState(false);

  useEffect(() => {
    let timeoutId;
    const rafId = requestAnimationFrame(() => {
      timeoutId = setTimeout(() => setPageReveal(true), 80);
    });
    return () => {
      cancelAnimationFrame(rafId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  return (
    <AuthProvider>
      <ContentProvider>
        <EditModeProvider>
        <ActivityLogProvider>
    <Router>
      <Seo />
      <Header />
      <SignInModal />
      <ProfileSettingsModal />
      <EditModeBanner />
      <EditorPanel />
      <RichTextToolbar />
      <div
        className={`App page-load-wrap ${pageReveal ? 'page-reveal' : ''}`}
        aria-busy={!pageReveal}
        aria-live="polite"
      >
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ministries" element={<Ministries />} />
            <Route path="/beliefs" element={<Beliefs />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/watch" element={<Watch />} />
            <Route path="/story" element={<Story />} />
            <Route path="/visit-us" element={<Visit />} /> 
            <Route path="/new-here" element={<NewHere />} />
            <Route
              path="/admin/activity"
              element={(
                <ProtectedRoute>
                  <ActivityLog />
                </ProtectedRoute>
              )}
            />
          </Routes>
        </main>
        <Footer />
      </div>
      <Chatbot />
    </Router>
        </ActivityLogProvider>
        </EditModeProvider>
      </ContentProvider>
    </AuthProvider>
  );
}

export default App;
